export enum ProcessNames {
  Registration = 'registration',
  Onboarding = 'onboarding',
  OneMinuteScreening = 'one-minute-screening',
  TimetrackingApproval = 'timetracking-approval',
  RateYourWeek = 'rate-your-week',
  CompleteProfile = 'complete-profile',
  SignDocument = 'sign-document',
  ShareData = 'share-data',
  ConsentUpdate = 'consent-update',
}

export enum ProcessSteps {
  OnboardingStart = 'onboarding_start',
  OnboardingPersonalInfo = 'onboarding_personal_info',
  OnboardingAddress = 'onboarding_address',
  OnboardingNotificationPreferences = 'onboarding_notification_preferences',
  OnboardingEmergencyContact = 'onboarding_emergency_contact',
  OnboardingIdUpload = 'onboarding_id_upload',
  OnboardingBigNumber = 'onboarding_big_number',
  OnboardingCompanyInfo = 'onboarding_company_info',
  OnboardingFinancialContact = 'onboarding_financial_contact',
  OnboardingDocuments = 'onboarding_documents',
  OnboardingFinished = 'onboarding_finished',

  TimetrackingApprovalWeekStart = 'timetracking_approval_week_start',
  TimetrackingApprovalDayStart = 'timetracking_approval_day_start',
  TimetrackingApprovalOverview = 'timetracking_approval_overview',
  TimetrackingApprovalCustomer = 'timetracking_approval_customer',
  TimetrackingApprovalWorklocation = 'timetracking_approval_worklocation',
  TimetrackingApprovalSignature = 'timetracking_approval_signature',
  TimetrackingApprovalEmail = 'timetracking_approval_email',

  CompleteProfileStart = 'complete_profile_start',
  CompleteProfilePersonalData = 'complete_profile_personal_data',
  CompleteProfileAddress = 'complete_profile_address',
  CompleteProfileFinished = 'complete_profile_finished',

  SignDocumentStart = 'sign_document_start',
  SignDocumentMetadata = 'sign_document_metadata',
  SignDocumentPreview = 'sign_document_preview',
  SignDocumentSignVerification = 'sign_document_sign_verification',
  SignDocumentRejectVerification = 'sign_document_reject_verification',

  OneMinuteScreeningStart = 'one_minute_screening_start',

  RegistrationStart = 'registration_start',
  RegistrationName = 'registration_name',
  RegistrationPhone = 'registration_phone',
  RegistrationLinkEmail = 'registration_link_email',
  RegistrationLinkPhone = 'registration_link_phone',

  ShareDataStart = 'share_data_start',

  ConsentUpdateStart = 'consent_update_start',
}